export default __webpack_public_path__ + "101636533065feb4b0d86bdee74c54af.svg";